import { uiGameManager } from '../../shared/scripts/EntryShared.ts';
import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
(function(GameFont) {
    (function(Size) {
        Size[Size["Small"] = 10] = "Small";
        Size[Size["Normal"] = 12] = "Normal";
        Size[Size["L"] = 14] = "L";
        Size[Size["XL"] = 16] = "XL";
        Size[Size["XXL"] = 26] = "XXL";
        Size[Size["XXXL"] = 42] = "XXXL";
        Size[Size["Giant"] = 60] = "Giant";
    })(GameFont.Size || (GameFont.Size = {}));
    (function(Weight) {
        Weight["Normal"] = "400";
        Weight["SemiBold"] = "600";
        Weight["Bold"] = "700";
    })(GameFont.Weight || (GameFont.Weight = {}));
    function getResponsiveSize(size) {
        if (UIUtilsEjsVariables.isUserOnTabletApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return size * uiGameManager.canvasController.appH / 600;
        return size * uiGameManager.canvasController.appH / 700;
    }
    GameFont.getResponsiveSize = getResponsiveSize;
})(GameFont || (GameFont = {}));
export var GameFont;
